<template>
  <div class="pb-5">
    <nav-bar />
    <div class="filter-buttons-header">
        <div class="filter-button-group">
            <toggle-button-group
            :buttons="offerFilterOptions" 
            :activeButton="getSelectedOffer" 
            :handleClick="handleFilterButtonClick" 
            />
        </div>
        <div v-if="getSelectedOffer === 'ACTIVE'" class="filter-button-group">
            <toggle-button-group
            :buttons="zoneFilterOptions" 
            :activeButton="selectedZoneFilter" 
            :handleClick="handleZoneFilterButtonClick" 
            />
        </div>
        <div v-if="getSelectedOffer === 'CLOSED'" class="filter-button-group">
            <toggle-button-group
            :buttons="closedOfferFilterOptions" 
            :activeButton="selectedClosedOffer" 
            :handleClick="handleClosedToggleClick" 
            />
        </div>
    </div>
    <div class="kne-title card-header m-2">
        <h2>{{ $t('Marketplace.title') }}</h2>
    </div>

    <div class="offers-filters col-12">
      <table class="table">
        <tr>
          <td>
            <regular-input
              :value="filters"
              @input="filters = $event"
              type="text" :placeholder="$t('Marketplace.search')"/>
          </td>
        </tr>
      </table>
    </div>

    <!-- Offers List -->
    <div class="offers-list" :key="mountKey">
      <div v-for="offer in searchfilterOffers ? searchfilterOffers : filteredOffers" :key="offer.id" class="offer-item">
        <div v-if="isNotClosed(offer)">
        <div class="offer-summary" @click="toggleOfferDetails(offer)">
          <div class="offer-summary-content">
            <span class="offer-vehicle">{{ offer.id }} &nbsp; &nbsp; &nbsp; {{ offer.year }} {{ offer.make }} {{ offer.model }}</span>
            <span class="offer-date">{{ $t('Marketplace.created') }}: {{ formatDate(offer.dateCreated) }}</span>
            <span class="offer-transporter">{{ offer.transpName }}</span>
          </div>
          <span class="new-offer" v-if="isNewOffer(offer)">New</span>
          <span class="offer-expand-icon">{{ expandedOffers.includes(offer.id) ? '▼' : '▶' }}</span>
        </div>
        <div v-if="expandedOffers.includes(offer.id)" class="offer-details">
          <div class="offer-details-row">
            <div class="offer-details-column">
              <h3>{{ $t('Marketplace.vehicleDetailsTitle') }}</h3>
              <p class="mt-4"><strong>{{ $t('Marketplace.vin') }}:</strong> {{ offer.vin }}</p>
              <p class="mt-2"><strong>{{ $t('Marketplace.model') }}:</strong> {{ offer.model }}</p>
              <p class="mt-2"><strong>{{ $t('Marketplace.make') }}:</strong> {{ offer.make }}</p>
              <p class="mt-2"><strong>{{ $t('Marketplace.trim') }}:</strong> {{ offer.trim }}</p>
              <p class="mt-2"><strong>{{ $t('Marketplace.year') }}:</strong> {{ offer.year }}</p>
              <p class="mt-2"><strong>{{ $t('Marketplace.provider') }}:</strong> {{ offer.transpName }}</p>
              <p class="mt-2"><strong>{{ $t('Marketplace.dateCreated') }}:</strong> {{ formatDate(offer.creationDate) }}</p>
            </div>
            <div class="offer-details-column">
              <h3>{{ $t('Marketplace.pickupDeliveryTitle') }}</h3>
              <div class="address-box">
                <h4>{{ $t('Marketplace.pickupAddress') }}</h4>
                <p>{{ $realName(offer, 'transmitter') }}</p>
                <p>{{ offer.transmitterAddress }}</p>
                <p>{{ offer.transmitterCity }}, {{ offer.transmitterProvince }} {{ offer.transmitterPostcode }}</p>
                <p>{{ offer.transmitterCountry }}</p>
              </div>
              <div class="address-box">
                <h4>{{ $t('Marketplace.deliveryAddress') }}</h4>
                <p>{{ $realName(offer, 'receiver') }}</p>
                <p>{{ offer.receiverAddress }}</p>
                <p>{{ offer.receiverCity }}, {{ offer.receiverProvince }} {{ offer.receiverPostcode }}</p>
                <p>{{ offer.receiverCountry }}</p>
              </div>
            </div>
            <div v-if="getSelectedOffer !== 'CLOSED'" class="offer-details-column">
              <div class="offer-details-column">
              <h3>{{ isMyOffer(offer) ? $t('Marketplace.receivedBids') : $t('Marketplace.submitBid') }}</h3>
              <div v-if="isMyOffer(offer)">
                <div v-if="offer.offers && offer.offers.filter((off) => off.status !== 'DENIED').length > 0" class="bids-list">
                  <div v-for="(offerItem, index) in offer.offers.filter((off) => off.status !== 'DENIED')" :key="index" class="bid-item">
                      <div class="bid-header">
                        <h4>{{ $t('Marketplace.bidder') }}: <b>{{ offerItem.offersTable[0].userName }}</b></h4>
                      </div>
                      <div class="bid-content">
                        <div class="bid-details">
                          <span class="bid-detail amount"><strong>${{ offerItem.offersTable[0].amount }}</strong></span>
                          <span class="bid-detail"><strong>{{ $t('Marketplace.time') }}:</strong> {{ offerItem.offersTable[0].maximumTime }} {{ $t('Marketplace.days') }}</span>
                          <span class="bid-detail"><strong>{{ $t('Marketplace.willReportKne') }}:</strong> {{ offerItem.offersTable[0].termsAccepted ? $t('Marketplace.reportYes') : $t('Marketplace.reportNo') }}</span>
                          <span class="bid-detail"><strong>{{ $t('Marketplace.date') }}:</strong> {{ formatDate(offerItem.offersTable[0].timestamp) }}</span>
                        </div>
                        <div v-if="offer.provider !== offerItem.offersTable[0].userId && isCounterOffer && isCounterOffer.userId === offerItem.userId">
                          <input min="0" type="number" lang="en" id="counterBidAmount" v-model="isCounterOffer.counterBidAmount" @input="isCounterOffer.counterBidAmount = sanitizeNumber($event)" required>
                          <p class="red-text" v-show="errorMessage" v-html="errorMessage"></p>
                          <button @click="submitBid(offer.id, offerItem.userId, 'COUNTER')" class="action-button counter">{{ $t('Marketplace.counterBid') }}</button>
                          <button @click="cancelCounterBid" class="action-button decline">{{ $t('Marketplace.cancel') }}</button>
                        </div>
                        <div v-if="offer.provider !== offerItem.offersTable[0].userId && !isCounterOffer" class="bid-actions">
                          <button @click="acceptBid(offer.id, offerItem.userId, offerItem.offersTable[0])" class="action-button accept">{{ $t('Marketplace.accept') }}</button>
                          <button @click="declineBid(offer.id, offerItem.userId)" class="action-button decline">{{ $t('Marketplace.decline') }}</button>
                          <button @click="toggleCounterOffer(offerItem.userId)" class="action-button counter">{{ $t('Marketplace.counter') }}</button>
                        </div>
                      </div>
                  </div>
                </div>
                <p v-else="!offer.offers" class="no-bids">{{ $t('Marketplace.noBidsYet') }}</p>
              </div>
              <div v-else-if="checkIfPending(offer)" class="">
                <p class="no-bids">{{ $t('Marketplace.bidPlaced') }}</p>
              </div>
              <div v-else-if="checkIfDenied(offer)" class="">
                <p class="no-bids">{{ $t('Marketplace.bidDenied') }}</p>
              </div>
              <div v-else-if="checkIfCounter(offer)">
                <form @submit.prevent="submitBid(offer.id, companyUID, 'COUNTER_BID')" class="bid-form">
                  <p class="no-bids">{{ $t('Marketplace.receivedCounter') }}</p>
                  <div class="form-group">
                    <p :class="{ 'strikethrough': bidAtDifferentPrice }">
                      {{ $t('Marketplace.bidAtCounteredPrice') }}: <b>{{ getCounterBidPrice(offer) + ' $'}}</b>
                    </p>
                  </div>
                  <div class="form-group checkbox">
                    <input type="checkbox" id="bidAtDifferentPrice" v-model="bidAtDifferentPrice">
                    <label for="bidAtDifferentPrice">{{ $t('Marketplace.bidAtDifferentPrice') }}</label>
                  </div>
                  <div v-if="bidAtDifferentPrice" class="form-group">
                    <label for="bidAmount">{{ $t('Marketplace.bidAmount') }}*:</label>
                    <input type="number" lang="en" id="bidAmount" v-model="bidForm.amount" @input="bidForm.amount = sanitizeNumber($event)" required>
                  </div>
                  <div class="form-group">
                    <label for="maximumTime">{{ $t('Marketplace.maximumDeliveryTime') }}*:</label>
                    <input min=0 type="number" id="maximumTime" v-model="bidForm.maximumTime" required>
                  </div>
                  <div class="form-group radio-group">
                    <p>{{ $t('Marketplace.willYouReportKne') }}*</p>
                    <div class="radio-option">
                      <input type="radio" id="termsAcceptedYes" v-model="bidForm.termsAccepted" :value="true">
                      <label for="termsAcceptedYes">{{ $t('Marketplace.reportYes') }}</label>
                    </div>
                    <div class="radio-option">
                      <input type="radio" id="termsAcceptedNo" v-model="bidForm.termsAccepted" :value="false">
                      <label for="termsAcceptedNo">{{ $t('Marketplace.reportNo') }}</label>
                    </div>
                  </div>
                  <p class="red-text" v-show="errorMessage" v-html="errorMessage"></p>
                  <button type="submit" class="submit-bid">{{ $t('Marketplace.submitBid') }}</button>
                </form>
              </div>
              <form v-else @submit.prevent="submitBid(offer.id, companyUID, 'SUBMIT')" class="bid-form">
                <div class="form-group">
                  <p :class="{ 'strikethrough': bidAtDifferentPrice }">
                    {{ $t('Marketplace.bidAtRecommendedPrice') }}: <b>{{ offer.recommendedPrice + ' $'}}</b>
                  </p>
                </div>
                <div class="form-group checkbox">
                  <input type="checkbox" id="bidAtDifferentPrice" v-model="bidAtDifferentPrice">
                  <label for="bidAtDifferentPrice">{{ $t('Marketplace.bidAtDifferentPrice') }}</label>
                </div>
                <div v-if="bidAtDifferentPrice" class="form-group">
                  <label for="bidAmount">{{ $t('Marketplace.bidAmount') }}*:</label>
                  <input type="number" lang="en" id="bidAmount" v-model="bidForm.amount" @input="bidForm.amount = sanitizeNumber($event)" required>
                </div>
                <div class="form-group">
                  <label for="maximumTime">{{ $t('Marketplace.maximumDeliveryTime') }}*:</label>
                  <input min=0 type="number" id="maximumTime" v-model="bidForm.maximumTime" required>
                </div>
                <div class="form-group radio-group">
                  <p>{{ $t('Marketplace.willYouReportKne') }}*</p>
                  <div class="radio-option">
                    <input type="radio" id="termsAcceptedYes" v-model="bidForm.termsAccepted" :value="true">
                    <label for="termsAcceptedYes">{{ $t('Marketplace.reportYes') }}</label>
                  </div>
                  <div class="radio-option">
                    <input type="radio" id="termsAcceptedNo" v-model="bidForm.termsAccepted" :value="false">
                    <label for="termsAcceptedNo">{{ $t('Marketplace.reportNo') }}</label>
                  </div>
                </div>
                <p class="red-text" v-show="errorMessage" v-html="errorMessage"></p>
                <button type="submit" class="submit-bid">{{ $t('Marketplace.submitBid') }}</button>
              </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import ToggleButtonGroup from '../module/special-components/Other-components/ToggleButtonGroup.vue'
import * as firebaseUtil from '../../firebase.js'
import * as turf from '@turf/turf'
import firebase from 'firebase/app'
import 'firebase/auth'
import RegularInput from '../module/basic-components/regularInput.vue'

export default {
    name: 'Marketplace',
    components: {
        ToggleButtonGroup,
        RegularInput
    },

    data () {
        return {
            offers: [],
            offerFilterOptions: [
                { label: this.$t('Marketplace.currentOffers'), value: `ACTIVE`, route: '/Marketplace' },
                { label: this.$t('Marketplace.myOffers'), value: `MY_OFFERS`, route: `/Marketplace?myOffers=true` },
                { label: this.$t('Marketplace.closedOffers'), value: `CLOSED`, route: `/Marketplace?closedOffers=true` }
            ],
            closedOfferFilterOptions: [
                {label: this.$t('Marketplace.won'), value: `WON`},
                {label: this.$t('Marketplace.lost'), value: `LOST`},
                {label: this.$t('Marketplace.myOffers'), value: `My Offers`}

            ],
            zoneFilterOptions: [
                {label: this.$t('Marketplace.insideZone'), value: `INSIDE`},
                {label: this.$t('Marketplace.outsideZone'), value: `OUTSIDE`}
            ],
            selectedOfferFilter: 'ACTIVE',
            selectedZoneFilter: 'INSIDE',
            selectedClosedOffer: 'WON',
            firebaseUtil,
            expandedOffers: [],
            isRecommendedPrice: true,
            errorMessage: '',
            isError: '',
            isCounterOffer: null,
            mountKey: 0,
            bidAtDifferentPrice: false,
            bidForm: {
                amount: null,
                maximumTime: null,
                termsAccepted: null
            },
            alertsData: null,
            filters: '',
            searchfilterOffers: null
        }
    },

    async created () {
      await this.getOffers()
      this.selectedOfferFilter = this.getSelectedOffer
    },

    watch: {
      filters: {
        handler () {
          this.applyFilters()
        }
      }
    },

    methods: {
        sanitizeNumber (e) {
          return e.target.value.replace(/,/g, '.')
        },
        handleFilterButtonClick (buttonName) {
            this.resetSearchFilters()
            this.selectedOfferFilter = buttonName
            const selectedOption = this.offerFilterOptions.find(option => option.value === buttonName)
            if (selectedOption && selectedOption.route) {
                this.$router.push(selectedOption.route)
            }
        },
        handleZoneFilterButtonClick (buttonName) {
          this.resetSearchFilters()
          this.selectedZoneFilter = buttonName
        },
        handleClosedToggleClick (buttonName) {
          this.resetSearchFilters()
          this.selectedClosedOffer = buttonName
        },
        resetSearchFilters () {
          this.searchfilterOffers = null
          this.filters = ''
        },
        async getOffers () {
          const snapshot = await firebaseUtil.db.ref().child('database').child('offers').once('value')
          if (snapshot.exists()) {
            this.offers = Object.entries(snapshot.val()).map(([pushId, offerData]) => {
              const restructuredOffers = offerData.offers
                ? Object.entries(offerData.offers)
                    .filter(([key, _]) => key !== 'bidders' && key !== 'winner')
                    .map(([userId, offerDetails]) => {
                      return {
                        userId,
                        status: offerDetails.status,
                        provider: offerDetails.provider,
                        offersTable: Object.entries(offerDetails.offersTable || {}).map(([id, bidDetails]) => ({
                          userId: id,
                          ...bidDetails
                        }))
                      }
                    })
                : []

              const winner = offerData.offers && offerData.offers.winner ? offerData.offers.winner : null
              const bidders = offerData.offers && offerData.offers.bidders ? offerData.offers.bidders : []

              return {
                pushId,
                id: '' + offerData.id,
                status: offerData.status,
                provider: offerData.provider,
                dateCreated: offerData.dateCreated,
                recommendedPrice: offerData.recommendedPrice,
                offers: restructuredOffers,
                winner: winner,
                bidders: bidders,
                ...offerData.infos
              }
            })
            const alertsSnapshot = await firebaseUtil.db.ref().child('database').child('transporter').child(this.companyUID).child('alerts').child('marketplace').once('value')
            this.alertsData = alertsSnapshot.val()
          }
        },
        toggleCounterOffer (userId) {
          this.isCounterOffer = {
            userId: userId,
            counterBidAmount: 0
          }
        },
        cancelCounterBid () {
          this.isCounterOffer = null
        },
        isInsideZone (offer) {
          const zones = this.$store.state.userInfo.zones

          if (!offer.transmitterLat || !offer.transmitterLong || !offer.receiverLat || !offer.receiverLong) {
            console.warn('Offer is missing coordinate data:', offer)
            return false
          }

          const transmitterPoint = turf.point([offer.transmitterLong, offer.transmitterLat])
          const receiverPoint = turf.point([offer.receiverLong, offer.receiverLat])

          if (!zones || zones.length === 0) {
            return false
          } else {
            return zones.some(zone => {
              if (!Array.isArray(zone.coordinates) || zone.coordinates.length === 0) {
                console.warn('Invalid zone coordinates:', zone)
                return false
              }

              const closedCoordinates = [...zone.coordinates]
              if (JSON.stringify(closedCoordinates[0]) !== JSON.stringify(closedCoordinates[closedCoordinates.length - 1])) {
                closedCoordinates.push(closedCoordinates[0])
              }

              try {
                const polygon = turf.polygon([closedCoordinates])
                return turf.booleanPointInPolygon(transmitterPoint, polygon) || turf.booleanPointInPolygon(receiverPoint, polygon)
              } catch (error) {
                console.error('Error creating or checking polygon:', error, zone)
                return false
              }
            })
          }
        },

        isWonOffer (offer) {
          const user = this.companyUID
          return offer.winner === user
        },

        isLostOffer (offer) {
          const user = this.companyUID
          const offerMade = offer.offers.filter(off => off.userId === user)
          return (offer.winner !== user && offer.bidders.includes(user) && this.isDeniedOffer(offerMade[0], offer.id))
        },

        isDeniedOffer (offerMade) {
          if (offerMade) {
            return offerMade.status === 'DENIED'
          }
          return false
        },

        isMyOffer (offer) {
          return offer.status !== 'CLOSED' && offer.provider === this.companyUID
        },
        isNotClosed (offer) {
          return this.getSelectedOffer === 'CLOSED' || offer.status !== 'CLOSED'
        },
        isNewOffer (offer) {
          return this.alertsData && this.alertsData[offer.pushId] && (this.alertsData[offer.pushId].newOffer || this.alertsData[offer.pushId].newBid) || false
        },

        toggleOfferDetails (offer) {
          const isAlreadyExpanded = this.expandedOffers[0] === offer.id

          this.expandedOffers = isAlreadyExpanded ? [] : [offer.id]
          this.isRecommendedPrice = !isAlreadyExpanded

          if (!isAlreadyExpanded) {
            this.bidForm = {
                amount: null,
                maximumTime: null,
                termsAccepted: false
              }
              this.bidAtDifferentPrice = false
              this.isCounterOffer = null
          }

          if (this.alertsData && this.alertsData[offer.pushId] && (this.alertsData[offer.pushId].newOffer || this.alertsData[offer.pushId].newBid)) {
            firebaseUtil.db.ref().child('database').child('transporter').child(this.companyUID).child('alerts').child('marketplace').child(offer.pushId).set({newOffer: false, newBid: false})
              .then(() => {
                this.alertsData[offer.pushId].newOffer = false
                this.alertsData[offer.pushId].newBid = false
                const hasNewOffer = Object.values(this.alertsData).filter(item => item.newOffer || item.newBid).length
                this.$store.commit('setMarketplaceAlerts', hasNewOffer)
              })
              .catch(function (error) {
                console.log(error)
              })
          }
        },
        checkIfPending (offer) {
          const statusOffer = offer.offers && offer.offers.filter(off => off.userId === this.companyUID)[0]
          const status = statusOffer ? statusOffer.status === 'PENDING' : false
          return status
        },
        checkIfCounter (offer) {
          const statusOffer = offer.offers && offer.offers.filter(off => off.userId === this.companyUID)[0]
          const status = statusOffer ? statusOffer.status === 'COUNTER' : false
          return status
        },
        checkIfDenied (offer) {
          const statusOffer = offer.offers && offer.offers.filter(off => off.userId === this.companyUID)[0]
          const status = statusOffer ? statusOffer.status === 'DENIED' : false
          return status
        },
        getCounterBidPrice (offer) {
          const counterOffer = offer.offers && offer.offers.filter(off => off.userId === this.companyUID)[0]
          return counterOffer && counterOffer.offersTable[1] && counterOffer.offersTable[1].amount || 0
        },
        async submitBid (offerId, bidderId, bidType) {
            const offer = this.offers.find(offer => offer.id === offerId)
            const bidData = {
              amount: this.bidAtDifferentPrice ? this.bidForm.amount : (bidType === 'SUBMIT' ? offer.recommendedPrice : 0),
              maximumTime: this.bidForm.maximumTime,
              termsAccepted: this.bidForm.termsAccepted,
              userId: this.companyUID,
              userName: this.$store.state.userInfo.name,
              timestamp: Date.now()
            }
            if (bidType === 'COUNTER') {
              bidData.amount = this.isCounterOffer.counterBidAmount
            }
            if (bidType === 'COUNTER_BID') {
              const currBid = offer.offers.filter(off => off.userId === this.companyUID)[0]
              bidData.amount = this.bidAtDifferentPrice ? this.bidForm.amount : currBid.offersTable[1].amount
            }

            if (bidType === 'SUBMIT' || bidType === 'COUNTER_BID') {
              if (!bidData.amount || bidData.amount === 0 || !bidData.maximumTime || bidData.maximumTime === 0 || bidData.termsAccepted === null) {
                this.errorMessage = this.$t('Marketplace.missing_fields_error')
                return
              }
            } else if (bidType === 'COUNTER') {
              if (!bidData.amount || bidData.amount === 0) {
                this.errorMessage = this.$t('Marketplace.missing_fields_error')
                return
              }
            }
            try {
              const offerRef = firebaseUtil.db.ref().child('database').child('offers').child(offer.pushId)
              const offerSnapshot = await offerRef.once('value')
              const offerData = offerSnapshot.val()

              let bidders = offerData.offers ? offerData.offers.bidders || [] : []
              if (!bidders.includes(bidderId) && bidType !== 'COUNTER') {
                bidders.push(bidderId)
                await offerRef.child('offers/bidders').set(bidders)
              }

              const bidderOfferRef = offerRef.child(`offers`).child(bidderId)
              const bidderOfferSnapshot = await bidderOfferRef.once('value')
              if (bidderOfferSnapshot.exists()) {
                const offerTableRef = bidderOfferRef.child('offersTable')
                const offerTableSnapshot = await offerTableRef.once('value')
                if (offerTableSnapshot.exists()) {
                  const offersTable = offerTableSnapshot.val()
                  if (Array.isArray(offersTable)) {
                    if (bidType === 'COUNTER') {
                      if (offersTable[1]) {
                        offersTable[1] = bidData
                      } else {
                        offersTable.push(bidData)
                      }
                      await bidderOfferRef.child('status').set('COUNTER')
                    } else {
                      offersTable[0] = bidData
                      await bidderOfferRef.child('status').set('PENDING')
                    }
                    await offerTableRef.set(offersTable)
                  } else {
                    await offerTableRef.set([bidData, null])
                    await bidderOfferRef.child('status').set('PENDING')
                  }
                } else {
                  await offerTableRef.set([bidData, null])
                  await bidderOfferRef.child('status').set('PENDING')
                }
              } else {
                const newOfferData = {
                  offersTable: [bidData, null],
                  status: 'PENDING'
                }
                await bidderOfferRef.set(newOfferData)
              }

              this.bidForm = {
                amount: null,
                maximumTime: null,
                termsAccepted: false
              }

              if (bidType === 'COUNTER' || bidType === 'COUNTER_BID') {
                alert('Counter bid placed successfully!')
              }

              this.isRecommendedPrice = true
              this.isCounterOffer = false

              const companyId = offer.provider === this.companyUID ? bidderId : offer.provider
              await firebaseUtil.db.ref().child('database').child('transporter').child(companyId).child('alerts').child('marketplace').child(offer.pushId).child('newBid').set(true)
                .then(() => {})
                .catch(function (error) {
                  console.log(error)
                })
              await this.getOffers()
            } catch (error) {
              console.error('Error submitting bid:', error)
            }
          },

          async acceptBid (offerId, bidderId, bid) {
            const offer = this.offers.find(offer => offer.id === offerId)
            try {
              await firebaseUtil.db.ref().child('database').child('offers').child(offer.pushId).child('offers').child('winner').set(`${bidderId}`)
              await firebaseUtil.db.ref().child('database').child('offers').child(offer.pushId).child('status').set('CLOSED')
              await firebaseUtil.db.ref().child('database').child('offers').child(offer.pushId).child('offers').child(bidderId).child('status').set('ACCEPTED')

              if (bidderId) {
                try {
                  const user = firebase.auth().currentUser
                  if (!user) {
                    throw new Error('No authenticated user found')
                  }
                  const idToken = await user.getIdToken()

                  const response = await fetch(`${process.env.OFFER_API_ENDPOINT}/api/notify-winner`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': idToken
                    },
                    body: JSON.stringify({
                      offerId: offer.pushId,
                      winnerId: bidderId,
                      bid: bid
                    })
                  })

                  if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`)
                  } else {
                    alert('Offer accepted successfully!')
                  }

                  await firebaseUtil.db.ref().child('database').child('transporter').child(bidderId).child('alerts').child('marketplace').child(offer.pushId).child('newBid').set(true)
                    .then(() => {})
                    .catch(function (error) {
                      console.log(error)
                    })

                  offer.bidders.forEach(bidder => {
                    if (bidder !== bidderId) {
                      firebaseUtil.db.ref().child('database').child('transporter').child(bidder).child('alerts').child('marketplace').child(offer.pushId).set(null)
                        .then(() => {})
                        .catch(function (error) {
                          console.log(error)
                        })
                    }
                  })
                } catch (apiError) {
                  console.error('Error calling notify-winner API:', apiError)
                }
              } else {
                console.error('Winner email not found')
              }

              await this.getOffers()
              this.mountKey += 1
            } catch (error) {
              console.error('Error submitting bid:', error)
            }
          },

        async declineBid (offerId, bidderId) {
          const offer = this.offers.find(offer => offer.id === offerId)
          try {
            await firebaseUtil.db.ref().child('database').child('offers').child(offer.pushId).child('offers').child(bidderId).child('status').set('DENIED')
            await firebaseUtil.db.ref().child('database').child('transporter').child(bidderId).child('alerts').child('marketplace').child(offer.pushId).child('newBid').set(true)
              .then(() => {
                console.log('success')
              })
              .catch(function (error) {
                console.log(error)
              })
            await this.getOffers()
            this.mountKey += 1
          } catch (error) {
            console.error('Error submitting bid:', error)
          }
        },

        formatDate (timestamp) {
            return new Date(timestamp).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            })
        },

        applyFilters () {
          if (this.filters === '') {
            this.searchfilterOffers = null
          } else {
            this.searchfilterOffers = this.filteredOffers.filter(offer => {
              const vehicleName = offer.year + ' ' + offer.make + ' ' + offer.model
              return (
                offer.id.toLowerCase().includes(this.filters.toLocaleLowerCase()) ||
                vehicleName.toLowerCase().includes(this.filters.toLowerCase()) ||
                offer.transpName.toLowerCase().includes(this.filters.toLowerCase())
              )
            })
          }
        }
    },

    computed: {
        hasFullAccess () {
            return this.$store.state.userInfo.userType === 'full'
        },
        companyUID () {
            return this.$store.state.authorization.company
        },
        filteredOffers () {
          const offers = this.offers.filter(offer => {
            const isInCorrectZone = this.selectedOfferFilter === 'ACTIVE' ? this.selectedZoneFilter === 'INSIDE' ? this.isInsideZone(offer) : !this.isInsideZone(offer) : true
            let isCorrectClosedStatus = true
            let isCorrectOfferType = true
            if (this.selectedOfferFilter === 'CLOSED') {
              if (this.selectedClosedOffer === 'WON') {
                isCorrectClosedStatus = this.isWonOffer(offer)
              } else if (this.selectedClosedOffer === 'LOST') {
                isCorrectClosedStatus = this.isLostOffer(offer)
              } else if (this.selectedClosedOffer === 'MY_OFFERS') {
                isCorrectClosedStatus = this.isMyOffer(offer) && offer.status === 'CLOSED'
              }
            }
            if (this.selectedOfferFilter === 'MY_OFFERS') {
              isCorrectOfferType = this.isMyOffer(offer) && offer.status !== 'CLOSED'
            } else if (this.selectedOfferFilter === 'ACTIVE') {
              isCorrectOfferType = !this.isMyOffer(offer) && offer.status === this.selectedOfferFilter
            } else if (this.selectedOfferFilter === 'CLOSED') {
              isCorrectOfferType = (this.isMyOffer(offer) && this.selectedClosedOffer === 'MY_OFFERS' && offer.status === 'CLOSED') || (!this.isMyOffer(offer) && (offer.status === this.selectedOfferFilter || this.selectedClosedOffer === 'LOST'))
            }
            return isInCorrectZone && isCorrectOfferType && isCorrectClosedStatus
          })
          return offers
        },
        getSelectedOffer () {
          const keys = Object.keys(this.$route.query)

          if (keys.length === 0) {
            return 'ACTIVE'
          }
          if (keys[0] === 'myOffers') {
            return 'MY_OFFERS'
          }
          if (keys[0] === 'closedOffers') {
            return 'CLOSED'
          }
          return 'ACTIVE'
        }
    }
}
</script>

<style scoped>
.filter-buttons-header {
  display: flex;
}

.offers-list {
  margin: 20px 0.5rem;
}

.offer-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 15px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.offer-summary {
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: rgba(250, 230, 60, 0.6);
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.offer-summary:hover {
  background-color: rgb(250, 230, 60);
}

.offer-summary-content {
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
}

.offer-vehicle {
  font-weight: bold;
  flex-basis: 40%;
}

.offer-date, .offer-transporter {
  flex-basis: 30%;
}

.offer-expand-icon {
  margin-left: 10px;
}

.offer-details {
  padding: 20px;
  background-color: rgba(255, 251, 202, 0.6);
}

.offer-details-row {
  display: flex;
  flex-wrap: wrap;
  margin: -10px;
}

.offer-details-column {
  flex: 1 1 300px;
  padding: 10px;
  min-width: 300px;
}

.offer-details h3 {
    font-weight: 600;
}
.red-text {
    color: rgb(220, 0, 0);
}
.offer-details-column h3 {
  margin-bottom: 15px;
  color: #333;
}

.address-box {
  background-color: rgba(255, 220, 190, 0.6);
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
}

.address-box h4 {
  margin-bottom: 10px;
  color: #555;
}
.bids-list {
  max-height: 400px;  /* Adjust this value as needed */
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
}
.bid-item {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 15px;
  background-color: #c9ffc960;
  overflow: hidden;
}

.bid-header {
  background-color: #c9ffc999;
  padding: 10px 15px;
  border-bottom: 1px solid #e0e0e0;
}

.bid-header h4 {
  margin: 0;
  font-size: 1rem;
  color: #333;
}

.bid-content {
  padding: 15px;
}

.bid-details {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.bid-detail {
  font-size: 0.9rem;
}

.bid-detail.amount {
  font-size: 1rem;
}
.bid-detail strong {
  color: #555;
  margin-right: 5px;
}

.bid-actions {
  display: flex;
  justify-content: flex-end;
}

.action-button {
  padding: 5px 10px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.accept {
  background-color: #4CAF50;
  color: white;
}

.decline {
  background-color: #f44336;
  color: white;
}

.counter {
  background-color: #2196F3;
  color: white;
}

.action-button:hover {
  opacity: 0.8;
}

.no-bids {
  text-align: center;
  color: #777;
  font-style: italic;
}

.strikethrough {
  text-decoration: line-through;
  color: #888;
}

.bid-form .form-group {
  margin-bottom: 15px;
}

.bid-form label {
  display: block;
  margin-bottom: 5px;
  color: #555;
}

.bid-form input[type="number"],
.bid-form input[type="checkbox"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.bid-form .checkbox {
  display: flex;
  align-items: center;
}

.bid-form .checkbox input {
  width: auto;
  margin-right: 10px;
}

.radio-group {
  margin-bottom: 2rem;
}

.radio-group p {
  margin-bottom: 8px;
  font-weight: bold;
}

.radio-option {
  display: flex;
  margin-right: 20px;
}

.radio-option input[type="radio"] {
  margin-right: 1rem;
}

.submit-bid {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.submit-bid:hover {
  background-color: #0056b3;
}
.submit-bid:disabled:hover {
  background-color: #007bff;
  cursor: not-allowed;
}
.new-offer {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  color: red;
}
</style>
